import { useMutation } from "react-query";
import downloadTransactionsCSV from "../services/downloadTransactionsCSV";

function useDownloadTransactionsCSV() {
  return useMutation(["download-transaction-csv"], downloadTransactionsCSV);
}

export default useDownloadTransactionsCSV;
